import React, {
    useEffect,
    useLayoutEffect, useRef,
    useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import useGetClassData from 'hooks/useGetClassData';
import { isEmpty } from 'lodash';
import {useLocation, useNavigate} from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { activeSubmit } from 'state';
import styled from 'styled-components';
import {fadeIn} from "../../../../../styled/StyledComponent";

interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
}

const InstructorMessage = () => {
    const [text, setText] = useState("");
    const setSubmit = useSetRecoilState(activeSubmit);
    const {
        state: { createId },
    } = useLocation();
    const { data: classesData, stepData } = useGetClassData(createId, "getClassById");
    const navigate = useNavigate();

    const putMessage = async (text) => {
        await classesAPI.putClassMessage(createId, {
            data: {
                message: text
            }
        })
    };

    const saveRef = useRef(null);

    useEffect(() => {
        if (stepData?.message !== "" || stepData?.message !== undefined) {
            setText(String(stepData?.message == "null" ? "" : stepData?.message));
        }
    }, [stepData?.message]);

    const titleInputRef = useRef(null);

    useEffect(() => {
        titleInputRef?.current?.focus();
    }, [titleInputRef?.current]);

    useEffect(() => {
        setSubmit(true);
    }, []);

    return (
        <Container>
            <Contents>
                <Row style={{marginBottom:8}}>
                    <FormBox>
                        <dt>Welcome message <strong>*</strong></dt>
                        <dd>
                            <FormBoxItemWrap>
                                <li>
                                <FormItem style={{ width: "calc(100%)" }}>
                                        <textarea
                                            onMouseLeave={async ()=>{
                                                if(!isEmpty(text)) {
                                                    await putMessage(text)
                                                }

                                            }}
                                            onBlur={async ()=>{
                                                if(!isEmpty(text)) {
                                                    await putMessage(text)
                                                }
                                            }}
                                            ref={titleInputRef}
                                            value={text}
                                            onChange={(e)=>{setText(e.target.value)}}
                                            style={{ height: 200 }}
                                            placeholder="Enter a message for student who have purchased your class or coaching"
                                        />
                                        <TextLength>{1000 - text.length}</TextLength>
                                    </FormItem>
                                </li>
                            </FormBoxItemWrap>
                        </dd>
                    </FormBox>
                </Row>
            </Contents>
            <ButtonItems 
                onClick={putMessage}
            justifyContent={"flex-end"}>
                <Browse
                    className={"prev"}
                    style={{ marginRight: 15, width: 100, height: 40 }}>
                    <span style={{ marginLeft: 0, }}>Previous</span>
                </Browse>
                {/*<button>Continue</button>*/}
            </ButtonItems>
        </Container>
    );
};
export default InstructorMessage;

const Container = styled.div`
    //overflow-y: scroll;
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Contents = styled.div`
    padding: 20px 20px 20px 20px;
`;

const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom: 15px;
`;
const Col = styled.div<StyledComponentProps>`
    width: calc((100% - 18px) / 2);
`;
const Divider = styled.div`
    width: calc(140%);
    transform: translateX(-20%);
    height: 1px;
    background: #333;
    opacity: 0.3;
`;
const FormBox = styled.dl`
    > dt {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        /* opacity: 0.8; */
        margin-bottom: 8px;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;

const FormItem = styled.div`
    h2 {
        font-size: 14px;
        margin-bottom: 15px;
    }
    position: relative;
    > input[type="text"],
    select,
    textarea {
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 50px 12px 16px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;

const SelectArrow = styled.div`
    position: absolute;
    right: 16px;
    top: 15px;
`;

const ThumbnailWrap = styled.div`
    color: #333;
    font-size: 16px;
`;

const ThumbnailTitle = styled.h5`
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    > strong {
        font-size: 13px;
        font-weight: 600;
        color: #da1414;
        display: inline-block;
        margin-left: 1px;
        vertical-align: top;
    }
`;

const ThumbnailText = styled.p`
    margin-bottom: 15px;
    line-height: 22px;
`;

const ThumbnailUpload = styled.div`
    width: 100%;
    height: 180px;
    padding: 9px 8px;
    border: 1px dashed rgba(51, 51, 51, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;
        cursor: pointer;
    }
`;

const ThumbnailView = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &::after {
        width: 100%;
        height: 100%;
        position: absolute;
        background: #000;
        opacity: 0.5;
        content: "";
    }
`;

const ThumbnailButtonList = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    > li {
        margin: 0 4px;
    }
`;

const ThumbnailUploadButton = styled.button`
    width: 100%;
    height: 100%;
    > span {
        display: block;
        font-size: 18px;
        font-family: Europa-Regular;
        margin-top: 10px;
        line-height: 100%;
    }
`;

const ButtonItems = styled.div<StyledComponentProps>`
    padding: 25px 20px;
    display: flex;
    justify-content: space-between;
    border-top: solid 1px rgba(51, 51, 51, 0.3);
    button {
        width: 100px;
        height: 40px;
        border: 0;
        cursor: pointer;
        padding: 11px 15px 11px 14px;
        color: #fff;
        border-radius: 6px;
        background: #ddc160;
    }
`;

const FormItems = styled.div`
    border: solid 1px #33333360;
    border-radius: 15px;
    overflow: hidden;
`;
const FormInner = styled.div`
    padding: 15px 15px 10px 15px;
    position: relative;
`;
const FormItemDivider = styled.div`
    width: 100%;
    height: 1px;
    background: #33333360;
`;
const VideoItemsWrap = styled.div`
    padding: 30px 15px 20px 15px;
    h2 {
        color: "#000";
        margin-bottom: 3px;
        font-size: 16px;
        font-weight: 400;
    }
`;
const VideoItems = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
`;
const CheckBox = styled.div`
    display: flex;
    margin-right: 13px;
    align-items: center;
    span {
        padding-top: 2px;
        font-size: 16px;
        color: #212529;
    }
    div {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: solid 1px #333;
    }
`;
const Browse = styled.div`
    position: relative;
    transition: all 0.2s;
    cursor: pointer;
    height: 48px;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;
    flex: 1;
    width: 100%;
    max-width: 120px;
    &.prev{
        width: 100px;
        max-width: 100px;
        padding: 0!important;
    }
    &.add{
        width: 100px;
        max-width: 100px;
        padding: 0!important;
    }
    &:hover{
        background: #333;
        border-color: #333;
        span{
            color: #fff!important;
        }

        svg{
            path{
                fill: #fff!important;
            }
        }
        span{
            color: #fff;

        }
    }
    @media screen and (max-width: 768px) {
        width: 100%!important;
        min-width: 100%;
        max-width: 100%;
        min-height: 46px;
        &.prev{
            min-width: 95px;
            max-width: 95px;
            min-height: 40px;
        }
        &.add{
            min-width: 95px;
            max-width: 95px;
            min-height: 40px;
            height: 40px;
        }
    }
    span {
        margin-left: 10px;
        font-size: 18px;
        color: #333;
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    svg{
        width: 16px;
        height: 16px;
        path{
            fill: #333!important;
        }
    }
    input {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #333;
        opacity: 0;
        z-index: 3;
    }
`;
const CloseButton = styled.div`
    background: #333;
    position: absolute;
    right: 0;
    top: 0;
    width: 51px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
const RemoveButton = styled.div``;

const AddButton = styled.div`
    height: 48px;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;

    width: 129px;
`;

const AddChapter = styled.div`
    background: #333;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    width: 106px;
    height: 40px;
    justify-content: center;
    border-radius: 5px;
    margin-top: 15px;
    cursor: pointer;
    span {
        color: #fff;
        font-size: 18px;
        margin-right: 10px;
        font-weight: 400;
    }
`;

const Transcript = styled.div`
    h3 {
        margin-top: 20px;
        margin-bottom: 14px;
        font-size: 26px;
        font-weight: 700;
    }
`;
